var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPol1D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.302717 2.52651C-0.0386667 1.02524 1.37315 -0.282615 2.84398 0.172375L42.3278 12.3864C43.7986 12.8414 44.2254 14.718 43.0959 15.7642L12.7764 43.8512C11.6469 44.8975 9.80839 44.3288 9.467 42.8275L0.302717 2.52651Z",
    fill: "#032250"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPol1D);
export default __webpack_public_path__ + "static/media/pol1d.ed53d2862bfe2b8b40b87ad3adef7060.svg";
export { ForwardRef as ReactComponent };